/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { INodeProps, Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { /*ISearchCategoryViewProps, */ ISearchFormViewProps /*, ISearchKeywordViewProps, ISearchProductViewProps */ } from './components';
import { IMfrmAutosuggestViewProps } from './mfrm-autosuggest';
import SearchResultContainer from './components/search-result-container';

const SearchView: React.FC<IMfrmAutosuggestViewProps> = props => {
    const {
        Search,
        AutoSuggestAriaLabel,
        AutoSuggestAriaLabelText,
        searchText,
        AutoSuggest,
        form,
        SearchForm,
        FormWrapper,
        suggestions,
        isFocused,
        handleCloseDialog,
        recentlySearched,
        setFormText,
        suggestedSociLocations,
        data: {
            storeSelectorState: { result: storeSelectorState }
        }
    } = props;
    const handleClickProduct = async (product: any) => {

        const obj = {
            event_type: 'site_search',
            search_term: searchText,
            search_type: 'related-products-search',
            product_name: [`${product.productName}`],
            product_id: [`${product.uniqueId}`],
            product_variant_id: [`${product.retailVariantId}`]
        };

        // @ts-ignore
        utag.link(obj);

        var u_payload = {
            query: 'ProductName',
            autosuggestParams: {
                unbxdAttr: 'autosuggest',
                unbxdParam_autosuggestType: 'POPULAR_PRODUCTS',
                unbxdParam_pid: product.recordId,
                unbxdParam_autosuggestSuggestion: product.productName
            }
        };
        if (u_payload.hasOwnProperty('query')) {
            //@ts-ignore
            Unbxd.track('search', u_payload);
        }
    };

    const handleClickItem = (term: string, type: string) => {
        if (type === "Popular Searches") {
            var u_payload = {
                query: term,
                autosuggestParams: {
                    unbxdAttr: "autosuggest",
                    unbxdParam_autosuggestType: "TOP_SEARCH_QUERIES",
                    unbxdParam_autosuggestSuggestion: term
                }
            };
            if (u_payload.hasOwnProperty('query')) {
                //@ts-ignore
                Unbxd.track('search', u_payload);
            }
            // @ts-ignore
            utag.link({
                event_type: "site_search",
                search_term: term,
                search_type: "top-search-queries"
            });
        }
        else if (type === "Suggestions") {
            var u_payload = {
                query: term,
                autosuggestParams: {
                    unbxdAttr: "autosuggest",
                    unbxdParam_autosuggestType: "KEYWORD_SUGGESTION",
                    unbxdParam_autosuggestSuggestion: term
                }
            };

            if (u_payload.hasOwnProperty('query')) {

                // @ts-ignore
                utag.link({
                    event_type: "site_search",
                    search_term: term,
                    search_type: "keyword_suggestion"
                });

                //@ts-ignore
                Unbxd.track('search', u_payload);
            }
        }
    };

    return (
        <Module {...Search}>
            <Node className={`ms-search-overlay ${(isFocused || searchText && searchText.length >= 0) ? 'show' : 'hide'}`} />
            <Node className='ms-search__holder'>
                {_renderForm(form as ISearchFormViewProps, SearchForm, FormWrapper)}
                <Node {...AutoSuggest}>
                    {(isFocused || searchText && searchText.length >= 0) && !onblur ? (
                        <Node className={'ms-search__autoSuggest__scroll'}>
                            {searchText && searchText.length > 0 ? <Node {...AutoSuggestAriaLabel}>{AutoSuggestAriaLabelText}</Node> : ''}
                            <button type="button" onClick={handleCloseDialog} className="search-modal__close-button" aria-label="Close"></button>
                            <div className='autosuggest-popup'>
                                {
                                    searchText && searchText.length > 0
                                        ? <div className='search-header autosuggest-link' onClick={FormWrapper?.onSubmit}>
                                            <p>Search for <span className='search'>“{searchText}”</span>?</p>
                                        </div>
                                        : null
                                }
                                {
                                    suggestions?.response
                                    && <SearchResultContainer
                                        context={props.Search.moduleProps.context}
                                        data={suggestions}
                                        recentlySearched={recentlySearched}
                                        isSearchBarEmpty={searchText?.length === 0}
                                        onClickProduct={handleClickProduct}
                                        onClickItem={handleClickItem}
                                        onSubmit={FormWrapper?.onSubmit}
                                        setQuery={setFormText}
                                        suggestedSociLocations={suggestedSociLocations}
                                        preferredStore={storeSelectorState?.sociPreferredStore}
                                        resources={props.resources}
                                    />
                                }
                            </div>
                        </Node>
                    ) : (
                        <></>
                    )}
                </Node>
            </Node>
        </Module>
    );
};

const _renderForm = (form: ISearchFormViewProps, SearchForm: INodeProps, FormWrapper: INodeProps) => {
    return (
        <Node {...SearchForm}>
            <Node {...FormWrapper}>
                {form.input}
                {form.cancelBtn}
                {form.submitBtn}
            </Node>
        </Node>
    );
};

export default SearchView;